import {
  CLIENTS_LOADING_START,
  CLIENTS_LOADING_SUCCESS,
  CLIENTS_LOADING_FAILED,
  CHANGE_CLIENTS_PAGE,
  CHANGE_CLIENTS_LIMIT,
  //Поиск
  CHANGE_CLIENTS_SEARCH,
  START_CLIENTS_SEARCH,
  CLEAR_CLIENTS_SEARCH,
  //Сортировка
  CHANGE_CLIENTS_SORTING,
} from '../actions/clientsList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  clients: [],
  total: 0,
  limit: 15,
  activePage: 1,
  search: '',
  activeSearch: '',
  sorting: {
    sort: 'created_at',
    order: true,
  }
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case CLIENTS_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        clients: [],
        total: 0,
      };
    case CLIENTS_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        clients: action.payload.clients.customers,
        total: parseInt(action.payload.clients.total, 10),
      };
    case CLIENTS_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    case CHANGE_CLIENTS_PAGE:
      return {
        ...state,
        activePage: action.payload.activePage,   
      };
    case CHANGE_CLIENTS_LIMIT:
      return {
        ...state,
        limit: action.payload.activeLimit,
        activePage: INITIAL_STATE.activePage,
      };
    //Поиск
    case CHANGE_CLIENTS_SEARCH:
      return {
        ...state,
        search: action.payload.value
      };
    case START_CLIENTS_SEARCH:
      return {
        ...state,
        activeSearch: action.payload.value,
        activePage: INITIAL_STATE.activePage,
      };
    case CLEAR_CLIENTS_SEARCH:
      return {
        ...state,
        activeSearch: INITIAL_STATE.activeSearch,
        search: INITIAL_STATE.search,
        activePage: INITIAL_STATE.activePage,
      };
    //Сортировка
    case CHANGE_CLIENTS_SORTING:
      return {
        ...state,
        sorting: action.payload, 
        activePage: INITIAL_STATE.activePage,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}